import style from './Right.module.scss';

import { ButtonTheme, NavButton } from '@components/Button';
import { translate } from '@chaika/i18n/helper';

export interface RightContentParams {}

interface Props extends RightContentParams {
    page: string;
    payerId: string;
}

export function RightContent({ page, payerId }: Props) {
    return (
        <div className={style.root}>
            <NavButton
                theme={ButtonTheme.Primary}
                to={`/plan/new?payerId=${payerId}&currentPage=${page}`}
            >
                {translate('addProgram')}
            </NavButton>
        </div>
    );
}
